import React from 'react';
import ProductMedia from './../../../Product/ProductMedia';
import { epiPropertyValue } from '@avensia/nitro5-scope-episerver';
const MediaBlock = ({ productViewModel }) => {
    return (React.createElement(ProductMedia, { id: productViewModel.code, imageUrls: productViewModel.imageUrls || [productViewModel.mainImageUrl], name: epiPropertyValue(productViewModel.content.displayName) }));
};
export default MediaBlock;
